<template>
    <div style="background-color: #f4f4f5">
        <div class="container" id="section_account">
            <div class="row justify-content-center">
                <div class="col-12 d-flex justify-content-center" style="background-color: #028a83;">
                    <h3 style="color: #ffffff; font-weight: bold; margin-top: 0.5rem" class="">Valora tu experiencia. Nosotros sí te escuchamos</h3>
                </div>
                <div class="mb-3 w-100">
                    <img src="/img/imagen-encuesta-valoracion.jpg" alt="imagen-encuesta-valoracion.jpg" style="width: 100%">
                </div>
                <div class="col-12 d-flex justify-content-center mt-4">
                    <h1 style="margin-top: 0; margin-bottom: 0; font-weight: bold; vertical-align: baseline; font-size: 25px; line-height: 25px; text-align: center; color: #1d70b7;" align="center">
                        Pedido {{ valoracion.pedido.numero_pedido}} - Semana {{ valoracion.pedido.semana}}
                    </h1>
                </div>
                <div class="col-12 d-flex justify-content-center">
                    <span style="text-align: center; color: #1d70b7; line-height: 2rem;">Fecha de la compra {{ valoracion.pedido.fecha}}</span>
                </div>
                <div class="col-12 d-flex justify-content-center">
                    <a :href="route('account.pedidos')" style="text-decoration: underline; color: #028a83">
                        Ver mis pedidos
                    </a>
                </div>
                <div class="col-12 d-flex justify-content-center">
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <h3>¿Estás contento con la calidad de la planta suministrada?</h3>
                </div>
                <div class="col-12 d-flex justify-content-center mt-4">
                    <star-rating :star-size="starSizeNumber" :show-rating="false" v-bind:min-rating="0" v-model="valoracionData.rate_plant"></star-rating>
                </div>
            </div>
            <hr>
            <template v-if="!isRecogidaBabyplant">
                <div class="row">
                    <div class="col-12 d-flex justify-content-center">
                        <h3>¿Has recibido el paquete con algún daño que resaltar?</h3>
                    </div>
                    <div class="col-12 d-flex justify-content-center mt-3">
                    <textarea v-model="valoracionData.observations" style="width: 80%; max-width: 600px; background-color: #f3f2f2; border-radius: 0; color: #818282; border-color: #818282" class="form-control" name="observations" id="observations" rows="3"
                              placeholder="Escribir comentario"></textarea>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-12 d-flex justify-content-center">
                        <h3>¿Estás satisfecho con el tiempo de espera hasta que has recibido las plantas?</h3>
                    </div>
                    <div class="col-12 d-flex justify-content-center mt-4">
                        <star-rating :star-size="starSizeNumber"  :show-rating="false" v-bind:min-rating="0"  v-model="valoracionData.rate_service"></star-rating>
                    </div>
                </div>
                <hr>
            </template>
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <h3>¿Recomendarías Babyplant Store a un amigo?</h3>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col-6 d-flex justify-content-end">
                    <div style="width: 100px;" class="recommendButton py-2 text-center" @click="() => {valoracionData.would_recommend = 'si'}" :class="{recommendSelected: wouldRecommend}">
                        <span style="color: white" >SI</span>
                    </div>
                </div>
                <div class="col-6 d-flex justify-content-start">
                    <div style="width: 100px;" class="recommendButton py-2 text-center" @click="() => {valoracionData.would_recommend = 'no' }" :class="{recommendSelected: wouldntRecommend}">
                        <span style="color: white">NO</span>
                    </div>
                </div>
            </div>
            <div class="row" v-if="this.valoracionData.voted">
                <div class="col-12 d-flex justify-content-center mt-4">
                    <p style="color: #019690; font-weight: bold" class="text-center">
                        ¡Gracias por confiar en Babyplant!<br>
                        Tu opinión nos ayudará a mejorar para ofrecer el mejor servicio
                    </p>
                </div>
            </div>
            <div class="row justify-content-center mb-4 mt-2" v-if="this.valoracionData.voted">
                <a :href="this.route('index')" class="col-5 d-flex justify-content-center py-1" style="border: 1px solid #a9aaa9; color: #a9aaa9; cursor: pointer">
                    VOLVER A LA TIENDA
                </a>
            </div>

            <div class="row justify-content-center" v-if="!this.valoracionData.voted">
                <div class="col-5 my-5 justify-content-center" style="min-width: 200px">
                    <div class="d-block text-center py-2 btn btn-enviar-opinion" @click="submitValoracion">
                        ENVIAR
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <p style="color: #353535; font-weight: bold" class="text-center">
                        Si tuviste algún problema y quieres iniciar una reclamación envía un correo a <a href="mailto:clientes@babyplant.es" style="color: #019690">clientes@babyplant.es</a>
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import StarRating from 'vue-star-rating';

    export default {
        name: "EncuestaEnvioComponent",
        components: {
            StarRating
        },
        props: ['valoracion'],
        data: function () {
            return {
                valoracionData: _.cloneDeep(this.valoracion),
                starSizeNumber: 40,
                submitting: false,
            }
        },
        methods: {
            setRateService: function (rating) {
                this.valoracionData.rate_service = rating;
            },
            setRatePlant: function (rating) {
                this.valoracionData.rate_plant = rating;
            },
            submitValoracion: function () {

                if(this.submitting || this.valoracionData.voted){
                    return;
                }

                this.submitting = true;

                let rate_service = this.valoracionData.rate_service;
                let observations = this.valoracionData.observations;
                if (this.isRecogidaBabyplant) {
                    rate_service = 5;
                    observations = 'RECOGIDA_EN_TIENDA';
                }

                axios.post(this.route("account.store.valoracion.entrega"), {
                    id: this.valoracionData.id,
                    observations: observations,
                    pedido_id: this.valoracionData.pedido_id,
                    rate_plant: this.valoracionData.rate_plant,
                    rate_service: rate_service,
                    would_recommend: this.valoracionData.would_recommend
                }).then((res) => {

                    this.valoracionData.voted = true;
                }).catch((err) => {

                    this.submitting = false;

                    if(err.response.status == 422){
                        Vue.toasted.show('Asegurate de contestar todos los campos', {
                            type: "error",
                            duration: 3000
                        });
                    }else{
                        Vue.toasted.show('Error al intentar guardar la encuesta. Inténtalo más tarde.', {
                            type: "error",
                            duration: 3000
                        });
                    }

                }).finally(() => {
                    this.submitting = false;
                });


            }

        },
        computed:{
            wouldRecommend: function () {
                return this.valoracionData.would_recommend === "si";
            },
            wouldntRecommend: function () {
                return this.valoracionData.would_recommend === "no";
            },
            isRecogidaBabyplant() {
                return !!this.valoracionData.pedido.is_recogida_en_babyplant;
            }
        },
    }
</script>

<style scoped>

    hr{
        width: 90%;
        border-bottom: 1px solid #979797;
        margin-top: 4em;
        margin-bottom: 4em;
    }

    h3{
        font-size: 1.5rem;
        text-align: center;
        color: #353535;
    }


    .recommendButton{
        background-color: #9c9b9b;
        cursor: pointer !important;
        font-weight: bold;
    }

    .recommendSelected{
        background-color: #019690 !important;
    }

    #section_account {
        background-color: #ffffff;
        max-width: 700px;
    }

    .btn-enviar-opinion {
        font-size: 17px;
        width: 100%;
        font-weight: bold;
        padding: 5px;
        margin-top: 10px;
        color: #ffffff;
        background-color: #1d70b7;
        border-color: #1d70b7;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
    }

    .btn-enviar-opinion:hover {
        background-color: #0a5799;
    }

</style>
